module.exports = "/_next/static/images/6f78ea8a13e9a6ef9e78ad440c30b20b-hero-large.jpg";